import { SlenderAuthResponse } from '@/interfaces/SlenderAuthResponse';

export class GumshoeUser {
  public user: string;
  public roles: string[];

  public get isAuthenticated() {
    return this.authed;
  }
  private authed = false;
  constructor(cookie?: string, response?: SlenderAuthResponse) {
    try {
      if (response) {
        this.user = response.name;
        this.roles = response.roles;
        this.authed = true;
      } else if (cookie) {
        const model = JSON.parse(cookie);
        this.user = model.name;
        this.roles = model.roles;
        this.authed = true;
      } else {
        this.authed = false;
      }
    } catch {
      this.authed = false;
    }
  }
}
